import { render, staticRenderFns } from "./ItemAAS.vue?vue&type=template&id=39d0384c&scoped=true&"
import script from "./ItemAAS.vue?vue&type=script&lang=js&"
export * from "./ItemAAS.vue?vue&type=script&lang=js&"
import style0 from "./ItemAAS.vue?vue&type=style&index=0&id=39d0384c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d0384c",
  null
  
)

export default component.exports